import { useEffect, useRef, useState } from 'react';
import Plus from '../../../../assets/images/plus-circle.svg';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ModalPortal } from '../../../ModalPortal';

export const AddToSection = ({ joinCode = '' }) => {
  const popupContentRef = useRef(null);
  const popUpRef = useRef(null);

  const [copied, setCopied] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupContentRef.current && !popupContentRef.current.contains(event.target) && popUpRef.current && !popUpRef.current.contains(event.target) && toggle) {
        setToggle(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [toggle]);

  const handleToggle = () => {
    if (!toggle && popUpRef.current) {
      const rect = popUpRef.current.getBoundingClientRect();
      const defaultTopOffset = 3;
      setPosition({
        top: defaultTopOffset + rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
      });
    }

    setToggle((prev) => !prev); // Always toggle on each click
  };

  return (
    <td className='position-relative w-99 p-2'>
      <p className='mb-0 cursor' onClick={handleToggle} ref={popUpRef}>
        <img src={Plus} alt='add ico' width={22} height={22} />
        Add
      </p>
      {toggle && (
        <ModalPortal>
          <div ref={popupContentRef} className='add-section d-flex flex-column align-items-start position-absolute border-transparent' style={{ right: '100px', zIndex: '11', top: `${position.top}px`, position: 'absolute' }}>
            <p className='student-link mb-0  fst-normal lh-normal text-lowercase'>{`${window.location.origin}/section/${joinCode}`}</p>
            {/* <p className="m-0 fs-14 cursor text-decoration-underline text-grey-800">C<span className="text-lowercase">opy link to clipboard</span></p> */}
            <p className='m-0 cursor'>
              <CopyToClipboard
                text={`${window.location.origin}/section/${joinCode}`}
                onCopy={() => {
                  setCopied(true);
                  setTimeout(() => {
                    setCopied(false);
                  }, 1500);
                }}
              >
                <div className='fs-14 border-transparent text-lowercase text-grey-800 fw-500 text-decoration-underline'>
                  {!copied && (
                    <>
                      <span className='text-uppercase'>C</span>opy link to clipboard
                    </>
                  )}
                  {copied && (
                    <span className='m-0 d-flex align-items-center border-transparent'>
                      <img src='/assets/images/linke.png' className='m-0' alt='link icon' width={13} height={10} />
                      Copied
                    </span>
                  )}
                </div>
              </CopyToClipboard>
            </p>
          </div>
        </ModalPortal>
      )}
    </td>
  );
};
